module.exports = "https://i-jinbaozheng-network-website.oss-cn-shanghai.aliyuncs.com//img/zh.8847e0f0.png";